import { render, staticRenderFns } from "./NoCartProductsContainer.vue?vue&type=template&id=88278b9a&"
import script from "./NoCartProductsContainer.vue?vue&type=script&lang=js&"
export * from "./NoCartProductsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NoCartProductsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports